import { Seeder } from '../seeder'
import { bsConstants } from '../../module.constants'
import { SeedMessagePost, SeedMessageThread, SeedMessageThreads } from './interfaces'
import { TestSeedUsers, UserSeeder } from '../user'
import { ArcSeeder, SeedArc, SeedArcs } from '../arc'

export class MessageSeeder extends Seeder<SeedMessageThreads, {}, SeedMessageThread> {
  type = 'messageThread'
  maxModelCount = 3
  seedArcs!: SeedArcs
  seedUsers!: TestSeedUsers

  base = {
    state: bsConstants.MESSAGES.STATE.NEW,
    posts: []
  }

  constructor () {
    super()
    this.seedUsers = new UserSeeder().getTestDataObject()
    this.seedArcs = new ArcSeeder().getTestDataObject()
  }

  getLiveDataObject () {
    return undefined
  }

  getTestDataObject (): SeedMessageThreads {
    if (process.env.BUILD_MODE === 'master') {
      return {} as unknown as SeedMessageThreads
    }

    return {
      AllegianceArc: {
        id: this.getNextId(),
        ...this.base,
        arcId: this.seedArcs.Allegiance_NeverEnding10Day.id,
        reviewerUserId: this.seedUsers.StanRizzo.id,
        userId: this.seedArcs.Allegiance_NeverEnding10Day.userId,
        posts: [
          {
            message: this.faker.lorem.paragraph().substring(0, 150),
            userId: this.seedUsers.StanRizzo.id,
            state: bsConstants.MESSAGES.STATE.NEW
          },
          {
            message: this.faker.lorem.paragraph().substring(0, 150),
            userId: this.seedUsers.StanRizzo.id,
            state: bsConstants.MESSAGES.STATE.NEW
          },
          {
            message: this.faker.lorem.paragraph().substring(0, 150),
            userId: this.seedArcs.Allegiance_NeverEnding10Day.userId,
            state: bsConstants.MESSAGES.STATE.NEW,
            fromArcTeamId: this.seedArcs.Allegiance_NeverEnding10Day.arcTeamId
          },
          {
            message: this.faker.lorem.paragraph().substring(0, 150),
            userId: this.seedUsers.StanRizzo.id,
            state: bsConstants.MESSAGES.STATE.NEW
          },
          {
            message: 'Last message to show',
            userId: this.seedArcs.Allegiance_NeverEnding10Day.userId,
            state: bsConstants.MESSAGES.STATE.NEW,
            fromArcTeamId: this.seedArcs.Allegiance_NeverEnding10Day.arcTeamId
          }
        ]
      },
      DarkForceRising: {
        id: this.getNextId(),
        ...this.base,
        arcId: this.seedArcs.DarkForceRising.id,
        reviewerUserId: this.seedUsers.StanRizzo.id,
        userId: this.seedArcs.DarkForceRising.userId,
        posts: [
          {
            message: this.faker.lorem.paragraph().substring(0, 150),
            userId: this.seedUsers.StanRizzo.id,
            state: bsConstants.MESSAGES.STATE.NEW
          },
          {
            message: this.faker.lorem.paragraph().substring(0, 150),
            userId: this.seedUsers.StanRizzo.id,
            state: bsConstants.MESSAGES.STATE.NEW
          },
          {
            message: this.faker.lorem.paragraph().substring(0, 150),
            userId: this.seedArcs.DarkForceRising.userId,
            state: bsConstants.MESSAGES.STATE.NEW,
            fromArcTeamId: this.seedArcs.DarkForceRising.arcTeamId
          },
          {
            message: this.faker.lorem.paragraph().substring(0, 150),
            userId: this.seedUsers.StanRizzo.id,
            state: bsConstants.MESSAGES.STATE.NEW
          },
          {
            message: this.faker.lorem.paragraph().substring(0, 150),
            userId: this.seedArcs.DarkForceRising.userId,
            state: bsConstants.MESSAGES.STATE.NEW,
            fromArcTeamId: this.seedArcs.DarkForceRising.arcTeamId
          }
        ]
      },
      ChoicesOfOne: {
        id: this.getNextId(),
        ...this.base,
        arcId: this.seedArcs.ChoicesOfOne.id,
        reviewerUserId: this.seedUsers.StanRizzo.id,
        userId: this.seedArcs.ChoicesOfOne.userId,
        posts: [
          {
            message: 'Hey!',
            userId: this.seedUsers.StanRizzo.id,
            state: bsConstants.MESSAGES.STATE.NEW
          }
        ]
      },
      ChoicesOfOneBlocked: {
        id: this.getNextId(),
        ...this.base,
        arcId: this.seedArcs.ChoicesOfOne.id,
        reviewerUserId: this.seedUsers.LukeSkywalker.id,
        userId: this.seedArcs.ChoicesOfOne.userId,
        posts: [
          {
            message: 'I am blocked',
            userId: this.seedUsers.LukeSkywalker.id,
            state: bsConstants.MESSAGES.STATE.NEW
          }
        ]
      },
      Deceived: {
        id: this.getNextId(),
        ...this.base,
        arcId: this.seedArcs.Deceived.id,
        reviewerUserId: this.seedUsers.StanRizzo.id,
        userId: this.seedArcs.Deceived.userId,
        posts: [
          {
            message: 'Can only reply as ARC Team - not pen name.',
            userId: this.seedUsers.StanRizzo.id,
            state: bsConstants.MESSAGES.STATE.NEW
          }
        ]
      },
      TooManyCancellationsReported: {
        id: this.getNextId(),
        ...this.base,
        arcId: this.seedArcs.TooManyCancellationsReported.id,
        reviewerUserId: this.seedUsers.BadBoy.id,
        userId: this.seedArcs.TooManyCancellationsReported.userId,
        posts: [
          {
            message: 'I am sooo bad, report me!',
            userId: this.seedUsers.BadBoy.id,
            state: bsConstants.MESSAGES.STATE.FLAGGED
          }
        ]
      },
      MessageFromShadowBannedUser: {
        id: this.getNextId(),
        ...this.base,
        arcId: this.seedArcs.ChoicesOfOne.id,
        reviewerUserId: this.seedUsers.ShadowBan.id,
        userId: this.seedArcs.ChoicesOfOne.userId,
        posts: [
          {
            message: 'Message from shadow banned user, SHOULD NOT BE VISIBLE!',
            userId: this.seedUsers.ShadowBan.id,
            state: bsConstants.MESSAGES.STATE.NEW
          }
        ]
      },
      MessageFromStanOnHasReviewsArc: {
        id: this.getNextId(),
        ...this.base,
        arcId: this.seedArcs.HasReviews.id,
        reviewerUserId: this.seedUsers.StanRizzo.id,
        userId: this.seedArcs.HasReviews.userId,
        posts: [
          {
            message: 'Should show review details from Stan',
            userId: this.seedUsers.StanRizzo.id,
            state: bsConstants.MESSAGES.STATE.NEW
          }
        ]
      },
      // Random: this.generateRandomData()
    }
  }

  getFakeSeed (id: number): SeedMessageThread | undefined {
    const arcToUse = this.getSeedWithId<SeedArcs, SeedArc>(this.seedArcs, id)

    if (arcToUse !== void 0 && arcToUse.userClaims !== void 0) {
      const recipientUserId = arcToUse.userClaims[0].userId
      const posts: SeedMessagePost[] = []

      // Generate 5 random messages between the user / author
      for (let i = 0; i < 5; i++) {
        const zeroOrOne = Math.round(Math.random())
        posts.push({
          message: this.faker.lorem.paragraph().substring(0, 150),
          userId: zeroOrOne === 0 ? arcToUse?.userId : recipientUserId,
          state: bsConstants.MESSAGES.STATE.NEW,
          fromArcTeamId: zeroOrOne === 0 ? arcToUse?.arcTeamId : void 0
        })
      }

      return {
        id,
        ...this.base,
        arcId: arcToUse.id,
        reviewerUserId: recipientUserId,
        userId: arcToUse.userId,
        posts
      }
    }

    return void 0
  }
}
